import Swiper from 'swiper';
import { Navigation, Autoplay, A11y } from 'swiper/modules';

export class BaseSlider {

    constructor(querySelector) {
        this.querySelector = querySelector;
        this.swiperElement = document.querySelector(querySelector);
        this.slidesCount = this.swiperElement ? this.swiperElement.querySelectorAll('.swiper-slide').length : 0;
        this.swiper = null;

        this.baseSwiperOptions = {
            modules: [Navigation, Autoplay, A11y],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 32,
            centerInsufficientSlides: true,
            a11y: {
                scrollOnFocus: false
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: querySelector + '-button-next',
                prevEl: querySelector + '-button-prev',
                addIcons: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            },
            on: {
                afterInit: (swiper) => {
                    this.toggleSlider(swiper, this.slidesCount, swiper.params.slidesPerView)
                },
                breakpoint: (swiper, breakpointParams) => {
                    this.toggleSlider(swiper, this.slidesCount, breakpointParams.slidesPerView)
                }
            }
        };
    }

    initSlider() {
        if (!this.swiperElement) {
            console.warn(`No element found for selector: ${this.querySelector}`);
            return;
        }
        this.swiper = new Swiper(this.swiperElement, this.baseSwiperOptions);
    }

    toggleSlider(swiper, slidesCount, slidesPerView) {
        if (slidesCount > slidesPerView) {
            if (!swiper.enabled) {
                swiper.enable();
                document.querySelector(this.querySelector + '-navigation')?.classList.remove('d-none');
            }
        } else {
            if (swiper.enabled) {
                swiper.disable();
                document.querySelector(this.querySelector + '-navigation')?.classList.add('d-none');
            }
        }
    }
}